<template>
  <div class="body">
    <div class="title">
      轮播图设置
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/lunbotushezhi' }">轮播图设置</el-breadcrumb-item>
          <el-breadcrumb-item>修改轮播图</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div style="margin: -20px 0 20px;"><el-button size="mini" @click="$router.back()">返回</el-button></div>

    <el-card>
      <el-form ref="form" :model="lunbotuxiangqing" label-width="80px" :label-position="labelPosition">
        <el-form-item label="轮播图图片" label-width="10%">
          <div class="imgbox" v-if="lunbotuxiangqing.pic">
            <img :src="lunbotuxiangqing.pic" alt="" class="imgs">
            <img src="../../assets/img/shanchu.png" mode="" class="close"
                 @click="closeImgs" v-if="lunbotuxiangqing.pic !== ''" alt="">
          </div>
          <el-upload
            v-if="!lunbotuxiangqing.pic"
            class="upload-demo"
            ref="upload"
            action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic"
            :on-progress="progress"
            :on-success="handleAvatarSuccess"
            :limit="1"
            :before-upload="beforeUpload"
            :on-exceed="handleExceed"
            list-type="picture"
            :data="{token:token}"
            name='pic'
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="链接" label-width="10%">
          <el-radio-group v-model="lunbotuxiangqing.url_type">
            <el-radio :label="1">内部链接</el-radio>
            <el-radio :label="2">外部链接</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="链接地址" label-width="10%" prop="url">
          <el-input v-model="lunbotuxiangqing.url"  style="width: 30%"></el-input>
        </el-form-item>
        <el-form-item label="链接说明" label-width="10%" prop="url_remark">
          <el-input v-model="lunbotuxiangqing.url_remark"  style="width: 30%" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="启用状态" label-width="10%">
          <el-radio-group v-model="lunbotuxiangqing.is_status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">未启用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="addlunbotu">提交</el-button>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { editSwiper } from '@/api/login'
export default {
  name: 'index',
  computed: {
    ...mapState(['lunbotuxiangqing'])
  },
  data () {
    return {

      token: sessionStorage.getItem('token'),
      labelPosition: 'left',
      form: {
        radio: 3
      }
    }
  },
  created () {
    console.log('this.this.lunbotuxiangqing', this.lunbotuxiangqing)
  },
  methods: {
    closeImgs () {
      this.lunbotuxiangqing.pic = ''
    },
    addlunbotu () {
      const obj = {
        id: this.lunbotuxiangqing.id,
        token: sessionStorage.getItem('token'),
        pic: this.lunbotuxiangqing.pic,
        url_remark: this.lunbotuxiangqing.url_remark,
        is_status: this.lunbotuxiangqing.is_status,
        url: this.lunbotuxiangqing.url,
        url_type: this.lunbotuxiangqing.url_type
      }
      editSwiper(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$router.push('/lunbotushezhi')
        }
      })
    },
    handleAvatarSuccess (response, file, fileList) {
      console.log('res', response)
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: 'success',
          duration: '2000'
        })
        this.lunbotuxiangqing.pic = response.pic_url
        console.log(' this.addQuery.pic ', this.addQuery.pic)
      }
    },
    beforeUpload (file) {
      console.log(file)
      const promise = new Promise((resolve) => {
        this.$nextTick(function () {
          resolve(true)
        })
      })
      return promise // 通过返回一个promis对象解决
    },
    progress (event, file, fileList) {
      console.log('event', event, 'file', file, 'fileList', fileList)
      // this.addquery.font_url.push({ name: file })
    },
    // 文件数量过多时提醒
    handleExceed () {
      // this.$message({ type: 'info', message: '最多支持5个附件上传' })
    }
  }
}
</script>

<style scoped lang="less">
.imgbox{
  width: 188px;
  height: 188px;
  opacity: 1;
  background: rgba(0,0,0,0.00);
  border-radius: 5px;
  position: relative;
  .imgs{
    width: 100%;
    height: 100%;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    opacity: 1;
    background: #e54848;
    border-radius: 50%;
  }
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display:flex;
    flex-direction: row;
    align-items: center;
    .fansk{
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf{
      color: #3D9AFF;
    }
  }
}
</style>
